import { cx } from '../lib/cx';

export interface ProgressRingProps {
  value: number;
  max: number;
  size?: number;
  thickness?: number;
  label?: string;
  caption?: string;
  ariaLabel?: string;
  className?: string;
}

/**
 * Prsten dosljednosti ("4/5 treninga"). Inline SVG — bez chart biblioteke.
 * Boje dolaze iz `currentColor`, pa ih postavlja Tailwind klasa iz tokena.
 */
export function ProgressRing({
  value,
  max,
  size = 96,
  thickness = 8,
  label,
  caption,
  ariaLabel,
  className,
}: ProgressRingProps) {
  const safeMax = max > 0 ? max : 1;
  const ratio = Math.max(0, Math.min(1, value / safeMax));
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;

  return (
    <div className={cx('inline-flex flex-col items-center gap-2', className)}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          role="img"
          aria-label={ariaLabel ?? `${value}/${max}`}
        >
          <circle
            className="text-bg-alt"
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="currentColor"
            strokeWidth={thickness}
          />
          <circle
            className="text-accent transition-[stroke-dashoffset] duration-300"
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke="currentColor"
            strokeWidth={thickness}
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - ratio)}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center font-display text-[22px] font-semibold text-ink">
          {label ?? `${value}/${max}`}
        </span>
      </div>
      {caption && <span className="text-[12px] text-ink-muted">{caption}</span>}
    </div>
  );
}
